import React, { useState } from 'react'
import { isPromise } from '../../helpers/helpers'

export interface InputValidation {
    /**
     * The test function is called when the input value changes. If test is set to "required", input must not be null | undefined to pass
     */
    test:
        | 'required'
        | ((
              value: any,
              setValidation: (boolean) => any,
              setValidationMessage: (string) => any,
          ) => boolean | Promise<any>)
    /**
     * The message that will be displayed if the validation fails
     */
    message?: string
}

const useValidation = ({ name, value, label, form, validation }) => {
    const [isValid, setIsValid] = useState(!validation)
    const [isValidating, setIsValidating] = useState(false)
    const [message, setMessage] = useState(validation?.message ?? null)

    const setValidation = (state) => {
        setIsValid(state)
        setIsValidating(false)
    }
    const validate = (value) => {
        //  if not validation is required the input will always be considered valid
        if (!validation) {
            return null
        }
        let isValid
        setIsValidating(true)

        const typeOfValue = typeof value
        const { test } = validation
        if (test === 'required') {
            if (Array.isArray(value)) {
                isValid = value.length > 0
                // return value.length > 0
            }
            if (typeOfValue === 'string') {
                // return value.length > 0
                isValid = value.length > 0
            } else {
                isValid = value !== null && value !== undefined
            }
        } else if (typeof test === 'function') {
            isValid = test(value, setValidation, setMessage)
            //  Handle async validations
            if (isPromise(isValid)) {
                //  If using a form context, register the pending validation with the form
                if (form) {
                    // form.addPendingValidation(name)
                }
                isValid = null
                setIsValid(isValid)
                return
            }
        }
        isValid = Boolean(isValid)
        setIsValid(isValid)
        setIsValidating(false)
        return isValid
    }

    const getMessage = () => {
        if (!validation) {
            return null
        }

        if (message && typeof message === 'string') {
            return message
        } else if (message && typeof message === 'function') {
            return message(value)
        }
        return `${label || name} is required`
    }
    return {
        validate,
        isValid,
        isValidating,
        message: getMessage(),
    }
}

export default useValidation
